export function invoiceState(state) {
    if (state === 'paid')
        return 'bezahlt'
    if (state === 'open')
        return 'offen';
    if (state === 'pending')
        return 'wartet auf Bezahlung';
    if (state === 'canceled')
        return 'zurückgezogen';
    if (state === 'credited')
        return 'gutgeschrieben';
    if (state === 'balancing')
        return 'ausgleichend';
}

export function isFinalState(state) {
    return state === 'credited'
        || state === 'paid'
        || state === 'balancing'
        || state === 'canceled'
}
